import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Column, Row, Section } from "@react-email/components";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useParseStyles } from "@circle-react-shared/Emails/VisualEmailBuilder/Design/useParseStyles";
import { defaultStyles } from "./defaultStyles";

interface ProductCardProps
  extends Omit<ComponentPropsWithRef<"table">, "loading"> {
  "data-preview-mode": boolean;
  productImage?: ReactNode;
  productNameVariant?: ReactNode;
  productPrice?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const ProductCard = forwardRef<HTMLTableElement, ProductCardProps>(
  (
    { productImage, productNameVariant, productPrice, styles = {}, ...rest },
    ref,
  ) => {
    const inlineStyles = useParseStyles({
      baseStyles: {},
      styles,
      defaultStyles,
    });

    return (
      <Section style={inlineStyles} ref={ref} {...rest}>
        <Row style={{ paddingBottom: "12px" }}>
          <Column>{productImage}</Column>
        </Row>
        <Row style={{ paddingBottom: "8px" }}>
          <Column>{productNameVariant}</Column>
        </Row>
        <Row>
          <Column>{productPrice}</Column>
        </Row>
      </Section>
    );
  },
);

ProductCard.displayName = "ProductCard";
